<template>
  <el-dialog
    title="扫描预览手机ppt"
    :visible="value"
    width="500px"
    @close="handleClose"
    :close-on-click-modal="false"
    @open="generateQRCode"
    :append-to-body="true"
  >
    <div class="qrcode-con">
      <div class="title">手机二维码</div>

      <div class="empty" v-show="!qrcodeFlg"></div>

      <canvas
        ref="qrcodeCanvas"
        class="qrcode-canvas"
        v-show="qrcodeFlg"
      ></canvas>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcode";

import { mapState } from "vuex";
export default {
  name: "QRCode",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    width: { type: Number, default: 200 },
    tempIndex: {
      type: Number,
      default: 1,
    },
    // 其他props保持不变
  },
  data() {
    return {
      qrcodeFlg: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    async generateQRCode() {
      await this.$nextTick();
      if (!this.$refs.qrcodeCanvas) return;

      // 使用toCanvas方法并传入Canvas元素
      QRCode.toCanvas(
        this.$refs.qrcodeCanvas,
        `http://192.168.1.6:8083/#/pages/template/template${this.tempIndex}?userId=${this.userInfo.loginUser.id}&pdfId=${this.tempIndex}`,
        {
          width: this.width,
          margin: 0,
          color: {
            dark: this.foreground,
            light: this.background,
          },
        },
        (error) => {
          if (error) {
            console.error("生成二维码失败:", error);
            this.$refs.qrcodeCanvas.innerHTML = "二维码生成失败";
          }
        }
      );
      this.qrcodeFlg = true;
    },
    handleClose() {
      this.qrcodeFlg = false;
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.qrcode-con {
  margin: 0 auto;
}
.title {
  text-align: center;
  margin-bottom: 16px;
}
.empty {
  width: 100px;
  height: 100px;
  border: 1px solid #000000;
  margin: 0 auto;
}
.qrcode-canvas {
  display: block;
  margin: 0 auto;
}
</style>
